import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as userInteractionsSelectors from '../store/userInteractions'

import asyncComponent from '../components/HOC/asyncComponent'

const ConfirmationModalAsync = asyncComponent(() =>
  import('../components/ConfirmationModal' /* webpackChunkName: "confirmation-modal" */),
)

const ConfirmationModalContainer = ({isOpen}) => (isOpen ? <ConfirmationModalAsync /> : null)

ConfirmationModalContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isOpen: userInteractionsSelectors.confirmModalIsOpen,
})

export default connect(mapStateToProps)(ConfirmationModalContainer)
